import { useNavigate } from "@tanstack/react-router";

import { t } from "../../../i18n";
import { trpc } from "../../../lib/trpc";
import { Button, Dialog, FieldMessage } from "../../ui";

interface DeleteHouseholdDialogProps {
  householdId: string;
  name: string;
  open: boolean;
  onClose: () => void;
}

export function DeleteHouseholdDialog({
  householdId,
  name,
  open,
  onClose,
}: DeleteHouseholdDialogProps) {
  const navigate = useNavigate();
  const utils = trpc.useUtils();
  const remove = trpc.household.delete.useMutation({
    onSuccess: () => {
      utils.household.list.invalidate();
      onClose();
      navigate({ to: "/" });
    },
  });

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={t.household.settings.dangerZone.deleteDialog.title}
      description={t.household.settings.dangerZone.deleteDialog.description(name)}
      size="sm"
      footer={
        <>
          <Button onClick={onClose}>{t.common.cancel}</Button>
          <Button
            variant="danger"
            iconLeft="trash"
            isLoading={remove.isPending}
            onClick={() => remove.mutate({ groupId: householdId })}
          >
            {t.household.settings.dangerZone.deleteDialog.submit}
          </Button>
        </>
      }
    >
      {remove.isError && (
        <FieldMessage tone="error" className="text-sm">
          {remove.error.message}
        </FieldMessage>
      )}
    </Dialog>
  );
}
